import { render } from "./GooglePlayButton.vue?vue&type=template&id=19ca9ddc"
import script from "./GooglePlayButton.vue?vue&type=script&lang=js"
export * from "./GooglePlayButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__